/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import PageEditorBody from "components/WebsiteBuilderComponents/PageEditorBody/PageEditorBody";

const PageEditor = () => {
  useEffect(() => {
    document.title = "Page Editor";
  }, []);

  return (
    <main id="app">
      <Header moduleName="websitebuilder" />
      <PageEditorBody />
    </main>
  );
};

export default PageEditor;
